/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * スライド単価マスタ検索情報
 */
export interface Szza028aRequestSlideTankaMasterSrchInfDto { 
    /**
     * 調整単価コード：数字<br>　画面項目ID＝\'C001300\'
     */
    choseiTankaCode?: string | null;
    /**
     * 計算年月(年)：数字
     */
    calcYmt?: string | null;
    /**
     * 適用開始日付（From）：日付(yyyyMMdd)
     */
    applyStartDateFrom?: string | null;
    /**
     * 適用開始日付（To）：日付(yyyyMMdd)
     */
    applyStartDateTo?: string | null;
    /**
     * 適用終了日付（From）：日付(yyyyMMdd)
     */
    applyEndDateFrom?: string | null;
    /**
     * 適用終了日付（To）：日付(yyyyMMdd)
     */
    applyEndDateTo?: string | null;
}

